// extracted by mini-css-extract-plugin
export var active = "_r1-1";
export var circle = "_r1-0";
export var completed = "_r1-2";
export var connector = "_r1-4";
export var connectorCompleted = "_r1-7";
export var connectorSpacer = "_r1-5";
export var iconStrokeOverride = "_r1-8";
export var labelContainer = "_r1-6";
export var pending = "_r1-3";